export const CONTACT_BASE_URL = "https://courses-api-j67q.onrender.com";
// https://courses-api-j67q.onrender.com
